<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-row >
                <v-col xs="12" sm="12" md="9" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายละเอียดใบแจ้งหนี้/ใบกำกับภาษี</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-5 " style="border-radius: 15px;">
                    <section class="pa-3">
                        <v-form ref="setting" >
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/avatar_white.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลสมาชิก</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            
                            <v-row class="pl-10">
                               
                                <v-col xs="6" sm="6" md="6" lg="6" xl="6" cols="6" class="  ">
                                    <div class="text_title  mt-2"><span class="text-grey">เลขที่ใบเสร็จ : </span> {{ customer_data.invoice_code == null ? '-' : customer_data.invoice_code }}</div>
                                </v-col>
                                
                                <v-col xs="6" sm="6" md="6" lg="6" xl="6" cols="6" class="  ">
                                    <div class="text_title mt-2"><span class="text-grey">วันที่เอกสาร : </span> {{ customer_data.doc_date == null ? '-' : customer_data.doc_date }} </div>
                                </v-col>
                                <!-- <v-col cols="auto"></v-col> -->

                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" class="pt-0">
                                    <div class="text_title mt-2"><span class="text-grey">ชื่อผู้ซื้อ :</span> {{ customer_data.buyer_name == null ? '-' : customer_data.buyer_name }} {{ customer_data.branch_number }} </div>
                                </v-col>

                                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
                                    <div class="text_title"> <span class="text-grey">เลขที่ผู้เสียภาษี :</span> {{ customer_data.tax_number == null ? '-' : customer_data.tax_number }}</div>
                                </v-col>

                                <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
                                    <div class="text_title"> <span class="text-grey">ที่อยู่ :</span> {{ customer_data.address == null ? '-' : customer_data.address }}</div>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                    <div class="title_form_main">
                                        <div class="logo_timeline">
                                            <img src="@/assets/arin_assets/box.png">
                                        </div>
                                    </div>
                                    <div class="header-content py-1 pl-5 pr-5 text-center">
                                        <div class="content-font">ข้อมูลสินค้า</div>
                                    </div>
                                    </div>
                                </v-col>
                            </v-row>
                            
                            <v-row>
                                <v-col>
                                    <v-simple-table>
                                        <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-center" width="100">
                                                    <div class="font-16"> ลำดับ </div>
                                                    <div class="font-16"> No. </div>
                                                </th>
                                                <th class="text-left">
                                                    <div class="font-16"> รายการสินค้า </div>
                                                    <div class="font-16"> Description </div>
                                                </th>
                                                <th class="text-center">
                                                    <div class="font-16"> จำนวน </div>
                                                    <div class="font-16"> Quantity </div>
                                                </th>
                                                <th class="text-right">
                                                    <div class="font-16 mr-5"> ราคาต่อหน่วย </div>
                                                    <div class="font-16 mr-7"> Unit Price </div>
                                                </th>
                                                <th class="text-right">
                                                    <div class="font-16 mr-7"> ส่วนลด </div>
                                                    <div class="font-16 mr-5"> Discount </div>
                                                </th>
                                                <th class="text-right" >
                                                    <div class="font-16 mr-10"> จำนวนเงิน (บาท) </div>
                                                    <div class="font-16 mr-10"> Amount (Baht) </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in data_list" :key="i">
                                                <td class="text-center font-16">
                                                    <div class="font-16">{{ i+1 }}</div></td>
                                                <td>
                                                    <div class="font-16">{{ item.product_name }}</div>
                                                </td>
                                                <td class="text-center font-16">
                                                    <div class="font-16" >{{ parseInt(item.qty) }} {{item.unit_name == '-' ? '' : item.unit_name}}</div>
                                                </td>
                                                <td class="text-right font-16">
                                                    <div class="mr-10 font-16" v-if="item.is_promotion == 1">
                                                        -{{ formatPrice(item.price) }}
                                                    </div>
                                                    <div class="mr-10 font-16" v-else>
                                                        {{ formatPrice(item.price) }}
                                                    </div>
                                                </td>
                                                <td class="text-right font-16">
                                                    <div class="mr-7 font-16">
                                                        {{ formatPrice(item.discount) }}
                                                    </div>
                                                </td>
                                                <td class="text-right" >
                                                    <div class="mr-10 font-16" v-if="item.is_promotion == 1">-{{ formatPrice(parseFloat(item.total)) }}</div>
                                                    <div class="mr-10 font-16" v-else>{{ formatPrice(parseFloat(item.total)) }}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="4" class="text-right font-16">
                                                    <div class="font-16">รวมเงิน (Sub Total)</div> 
                                                </td>
                                                <td class="text-right">
                                                    <div class="mr-10 font-16">{{formatPrice(parseFloat(customer_data.total))}}</div> 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="4" class="text-right font-16">
                                                    <div class="font-16">ส่วนลดท้ายบิล (Discount)</div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="mr-10 font-16">{{formatPrice(customer_data.discount)}}</div> 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="4" class="text-right font-16">
                                                    <div class="font-16">มูลค่าสินค้า (Total)</div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="mr-10 font-16">{{formatPrice(customer_data.cost)}}</div> 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="4" class="text-right font-16">
                                                    <div class="font-16">ภาษีมูลค่าเพิ่ม (VAT) 7%</div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="mr-10 font-16">{{formatPrice(customer_data.vat)}}</div> 
                                                </td>
                                            </tr>
                                            <tr v-if="seller.pay_type.find(o => o === 3)">
                                                <td></td>
                                                <td colspan="4" class="text-right font-16">
                                                    <div class="font-16">เครดิตชาร์จ (credit charge) {{parseFloat(seller.credit_charge)}}%</div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="mr-10 font-16">{{formatPrice(parseFloat(customer_data.credit_uncharge) * parseFloat(seller.credit_charge_status == 1 ? parseFloat(seller.credit_charge) / 100 : 0))}}</div> 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td colspan="4" class="text-right font-16">
                                                    <div class="font-16">คะแนนส่วนลด (Discount Points)</div>
                                                </td>
                                                <td class="text-right">
                                                    <div class="mr-10 font-16">{{formatPrice(customer_data.use_point)}}</div> 
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td class="font-16">
                                                    <div class="font-16" v-if="!seller.pay_type.find(o => o === 3)">{{THBText(parseFloat(customer_data.net_total) - parseFloat(customer_data.use_point))}}</div>
                                                    <div class="font-16" v-else>{{THBText((parseFloat(customer_data.net_total) + parseFloat(customer_data.net_total) * parseFloat(seller.credit_charge_status == 1 ? parseFloat(seller.credit_charge) / 100 : 0))-(parseFloat(customer_data.use_point)))}}</div>
                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td class="text-right font-16">
                                                    <div class="font-16">ยอดเงินสุทธิ (NET Total)</div>
                                                </td>
                                                <td class="text-right ">
                                                    <div v-if="!seller.pay_type.find(o => o === 3)" class="mr-10 font-16">{{formatPrice(parseFloat(customer_data.net_total) - parseFloat(customer_data.use_point))}}</div> 
                                                    <div v-else class="mr-10 font-16">{{formatPrice(parseFloat(customer_data.net_total) -(parseFloat(customer_data.use_point)))}}</div> 
                                                </td>
                                            </tr>
                                        </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-form>
                    </section>
                </v-card>
            </div>
        </div>
    </div>
</template>
  
<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
import THBText from 'thai-baht-text'
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_invoices_tax_detail",
    data() {
        return {
            loading_page: false,
            dialog_cancel_order: false,
            customer_data:{
                store_id: null,
                invoice_code: null,
                doc_date: null,
                buyer_name: null,
                address: null,
                cost: null,
                discount: null,
                total: null,
                vat: null,
                use_point: null,
                net_total: null,
                net_total_text: null,
            },
            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },

            data_list: [
                {
                    product_no: '1',
                    product_name: 'tab.CARATEN 12.5 MG.BX 100 s 1300.-',
                    product_unit: '1 แผง',
                    product_price: '9.00',
                    product_sum: '9.00',
                },
                {
                    product_no: '2',
                    product_name: 'eent.NODOGLE SPRAY 15 ML. 150.-',
                    product_unit: '1 กล่อง',
                    product_price: '102.00',
                    product_sum: '102.00',
                },
            ],
            sub_menu:[
                {
                    text:'ระบบ POS',
                    disabled:false,
                },
                {
                    text:'การขาย',
                    disabled:false,
                },
                {
                    text:'ใบแจ้งหนี้/ใบกำกับภาษี',
                    disabled:false,
                },
                {
                    text:'รายละเอียดใบแจ้งหนี้/ใบกำกับภาษี',
                    disabled:false,
                },
            ],
            seller: {
                pay_type: [],
                credit_charge: null,
                credit_charge_status: null
            }
        }
    }, 
    methods: {
        THBText(text){
            return THBText(text)
        },
        formatPrice(number){
            return formatPrice(number)
        },
         async getDetail(){
             let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
              await  HTTP_ARIN.get(`/tax/invoice/detail/${this.$route.params.id}`, config).then((res) => {
                    if (res.data.successful === true) {
                       this.customer_data = res.data.data
                       this.customer_data.use_point = this.customer_data.use_point ? this.customer_data.use_point : '0.00'
                       this.data_list = res.data.data.product_list
                       this.customer_data.total = 0;
            this.data_list = this.customer_data.product_list.map(item => {
                if (item.is_promotion == 0) {
                    this.customer_data.total += parseFloat(item.total)
                } else if (item.is_promotion == 1) {
                    // ลบ total ของสินค้าที่เป็นโปรโมชั่น
                    this.customer_data.total -= parseFloat(item.total)
                }
                return { ...item }
            })
                        this.getStoreDetail()
                    }
                })
        },
         async getStoreDetail(){
                    this.seller.pay_type = this.customer_data.pay_type
                    this.seller.credit_charge_status = this.customer_data.credit_charge_status
                    this.seller.credit_charge = this.customer_data.credit_charge
         },
    },
    mounted(){
        this.getDetail()
    }
}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 100%; */
}
</style>
  